import {
  createApolloClient,
  getKraxiClientConfigPreset,
  gql,
  useKraxiQuery,
} from "@origin-digital/kraxi";
import { config } from "../../config";
import { DigitalUserAccounts } from "./graphql-types/DigitalUserAccounts";

export const gatewayClient = createApolloClient(
  getKraxiClientConfigPreset("gateway", config.env)
);

export const useGatewayDigitalUserAccounts = () =>
  useKraxiQuery<DigitalUserAccounts>(
    gql`
      query DigitalUserAccounts {
        viewer {
          digital {
            accounts {
              type
              status
            }
          }
        }
      }
    `,
    {
      client: gatewayClient,
    }
  );
